import { Divider } from "../../../../components/Divider";
import { RouteFullScreenModal } from "../../../../components/RouteFullScreenModal";
import { MutateProductGroupForm } from "../components";

export const NewProductGroupsPage = () => {
  return (
    <RouteFullScreenModal title="Create new product group">
      <Divider />
      <MutateProductGroupForm />
    </RouteFullScreenModal>
  );
};
